"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spec = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const effect_1 = require("effect");
const Json = __importStar(require("../../../../../../json"));
const openapi_1 = require("../../../../openapi");
const guard_1 = require("../guard");
const shared_1 = require("../shared");
const DeviceData = __importStar(require("./schema"));
exports.NAMESPACE = 'Culligan.Api.V1.Admin.Device.Data.Spec';
const LatestDataResponse = openapi_1.Response.Success(DeviceData.LatestData).annotations({
    description: 'Latest stored device datapoints',
});
const DatapointHistoryResponse = openapi_1.Response.Success(DeviceData.DatapointHistory).annotations({
    description: 'Paginated stored datapoint history',
});
const ConnectionStateResponse = openapi_1.Response.Success(DeviceData.ConnectionState).annotations({
    description: 'Live device connection state',
});
const ConnectionHistoryResponse = openapi_1.Response.Success(DeviceData.ConnectionHistory).annotations({
    description: 'Connection events from the last 90 days',
});
const EmptySuccessResponse = openapi_1.Response.EmptyData.annotations({
    description: 'Successful device mutation',
});
/*
 * 422 without `inputValidation`: the legacy JSON-schema model rejects the
 * query after express-validator and answers with its own error list.
 */
const LegacyModelValidation = openapi_1.Error.v1Rejected(`${exports.NAMESPACE}.LegacyModelValidation`, 'INVALID_REQUEST', 'Validation Error (Legacy Model Format)', 'The legacy JSON-schema model rejected the query. Carries no express-validator field errors.', { validation: effect_1.Schema.Array(Json.Record) });
// Query structs intentionally have no identifier (see shared.ts).
const SerialNumberQuery = effect_1.Schema.Struct({
    serialNumber: effect_1.Schema.NonEmptyString,
});
const DataHistoryQuery = effect_1.Schema.Struct({
    serialNumber: effect_1.Schema.NonEmptyString,
    properties: effect_1.Schema.Array(effect_1.Schema.String).pipe(effect_1.Schema.minItems(1)),
    dateFrom: effect_1.Schema.optionalWith(effect_1.Schema.String.pipe(effect_1.Schema.pattern(/^\d{4}-\d{2}-\d{2}$/)), { exact: true }),
    dateTo: effect_1.Schema.optionalWith(effect_1.Schema.String.pipe(effect_1.Schema.pattern(/^\d{4}-\d{2}-\d{2}$/)), { exact: true }),
    page: shared_1.page,
    pageSize: effect_1.Schema.optionalWith(shared_1.PositiveIntFromString.pipe(effect_1.Schema.lessThanOrEqualTo(1000)), {
        exact: true,
    }).annotations({ description: 'Default and maximum 1000' }),
    skipNulls: effect_1.Schema.optionalWith(effect_1.Schema.Literal('true', 'false'), { exact: true }),
});
const insertDatapoint = platform_1.HttpApiEndpoint.post('insertDatapoint') `/datapoints`
    .setPayload(DeviceData.DatapointInsertPayload)
    .addSuccess(EmptySuccessResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotFound)
    .annotate(platform_1.OpenApi.Title, 'Insert Device Datapoint')
    .annotate(platform_1.OpenApi.Description, 'For development or simulated devices only. source labels history but does not select the state/telemetry destination bucket.')
    .pipe(guard_1.withWriteGuard, openapi_1.Error.withV1StandardErrors);
const getLatestData = platform_1.HttpApiEndpoint.get('getLatestData') `/data`
    .setUrlParams(SerialNumberQuery)
    .addSuccess(LatestDataResponse)
    .addError(LegacyModelValidation)
    .addError(openapi_1.Error.V1NotFound)
    .annotate(platform_1.OpenApi.Title, 'Get Latest Device Data')
    .annotate(platform_1.OpenApi.Description, 'Returns a flat merge of telemetry and state (state wins on duplicate keys). A missing cache document may return 200 with empty datapoints and null lastUpdate; repository errors return 404.')
    .pipe(guard_1.withReadGuard, openapi_1.Error.withV1StandardErrors);
const getDataHistory = platform_1.HttpApiEndpoint.get('getDataHistory') `/data/history`
    .setUrlParams(DataHistoryQuery)
    .addSuccess(DatapointHistoryResponse)
    .addError(LegacyModelValidation)
    .annotate(platform_1.OpenApi.Title, 'Get Device Data History')
    .annotate(platform_1.OpenApi.Description, 'Returns requested properties newest-first. Missing property values are null; empty history returns 200. skipNulls is documented for one property but runtime does not enforce that limit.')
    .pipe(guard_1.withReadGuard, openapi_1.Error.withV1StandardErrors);
const getConnectionState = platform_1.HttpApiEndpoint.get('getConnectionState') `/connection-state`
    .setUrlParams(SerialNumberQuery)
    .addSuccess(ConnectionStateResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotFound)
    .annotate(platform_1.OpenApi.Title, 'Get Device Connection State')
    .annotate(platform_1.OpenApi.Description, 'Returns live connectivity and last IoT Hub activity time; this is the slim runtime shape, not the old rich DeviceState Swagger example.')
    .pipe(guard_1.withReadGuard, openapi_1.Error.withV1StandardErrors);
const getConnectionHistory = platform_1.HttpApiEndpoint.get('getConnectionHistory') `/connection-history`
    .setUrlParams(SerialNumberQuery)
    .addSuccess(ConnectionHistoryResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotAuthorized)
    .annotate(platform_1.OpenApi.Title, 'Get Device Connection History')
    .annotate(platform_1.OpenApi.Description, 'Returns up to 90 days of events with deviceId removed. Authentication is read RBAC (Bearer/CPort) OR ?sat=; SAT access is restricted to its named device.')
    .pipe(guard_1.withReadGuard)
    .middleware(openapi_1.Security.FleetSat)
    .pipe(openapi_1.Error.withV1StandardErrors);
exports.Spec = platform_1.HttpApiGroup.make('v1.admin.device.data')
    .add(insertDatapoint)
    .add(getLatestData)
    .add(getDataHistory)
    .add(getConnectionState)
    .add(getConnectionHistory)
    .prefix('/admin/device')
    .annotate(platform_1.OpenApi.Title, 'Device Data')
    .annotate(platform_1.OpenApi.Description, 'Admin device telemetry and connection endpoints')
    .pipe(openapi_1.Audience.withAudiences(openapi_1.Audience.Audience.Admin));
//# sourceMappingURL=spec.js.map